/**
 * @generated SignedSource<<c8455674618c6098d5019bc7558de9c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemptionCheckbox_transaction$data = {
  readonly canBeTaxExempt: boolean | null;
  readonly id: string;
  readonly reviews: ReadonlyArray<{
    readonly status: string | null;
    readonly type: string | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutTaxExemptionCheckbox_transaction";
};
export type CheckoutTaxExemptionCheckbox_transaction$key = {
  readonly " $data"?: CheckoutTaxExemptionCheckbox_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemptionCheckbox_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeTaxExempt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionReview",
      "kind": "LinkedField",
      "name": "reviews",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "1b803bd7e8832aa0df18ceb160cf108b";

export default node;
